import { Show } from "shared/components";
import Drawer from "react-modern-drawer";
import { useMedia } from "shared/providers";
import { Property } from "types/landlord/address";
import { AddProperty } from ".";

export const AddPropertyDrawer = ({
  open,
  newPropertyName,
  onClose,
  onSuccess
}: {
  open: boolean;
  newPropertyName?: string;
  onClose?: () => void;
  onSuccess?: (newProperty?: Property) => void;
}) => {
  const { isMobile } = useMedia();

  return (
    <Drawer
      zIndex={15}
      className="rounded-l-lg"
      direction="right"
      onClose={onClose}
      open={open}
      size={isMobile ? 380 : 640}
    >
      {/* Done to reset form's state */}
      <Show if={open}>
        <AddProperty
          isDrawerContent
          newPropertyName={newPropertyName}
          onClose={onClose}
          onSuccess={onSuccess}
        />
      </Show>
    </Drawer>
  );
};
